var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-svg",class:{ loaded: !_vm.isShow }},[_c('div',{staticClass:"modal-loading-content"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }